export const MessageModes = {
    Empty: 0,
    NewMessage: 1,
    Thread: 2
}
